import { createSlice } from '@reduxjs/toolkit'

export interface CustomerState {
  erpCusNo: string
  cnohash: string
  name: string
  adress: string
  zipCode: string
  city: string
  country: string
  email: string
  phone: string
  marketingOptIn: boolean | null
}

const initialState: CustomerState = {
  erpCusNo: '',
  cnohash: '',
  name: '',
  adress: '',
  zipCode: '',
  city: '',
  country: 'SE',
  email: '',
  phone: '',
  marketingOptIn: null, // bool (null if omitted)
}

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    handleCustomer(state, action) {
      const customer = action.payload

      const { erpCusNo, cnohash, name, adress, zipCode, city, country, email, phone, marketingOptIn } = customer

      if (erpCusNo) {
        state.erpCusNo = erpCusNo
      }

      if (cnohash) {
        state.cnohash = cnohash
      }

      if (name) {
        state.name = name
      }

      if (adress) {
        state.adress = adress
      }

      if (zipCode) {
        state.zipCode = zipCode
      }

      if (city) {
        state.city = city
      }

      if (country) {
        state.country = country
      }

      if (email) {
        state.email = email
      }

      if (phone) {
        state.phone = phone
      }

      if (marketingOptIn || marketingOptIn === false) {
        state.marketingOptIn = marketingOptIn
      }
    },
  },
})

export const { handleCustomer } = customerSlice.actions

export default customerSlice.reducer
